import React from 'react';
import './footer.css';

export default function Footer() {
	return (
		<footer className="site-footer">
			<div className="footer-content">
				<div className="footer-left">
					<div className="footer-logo">
						<img src="/images/logo-iusse.png" alt="Logo IUSSE" />
						<h2>IUSSE</h2>
					</div>
					<div className="footer-social">
						<h4>Suivez-nous</h4>
						<p className="social-text">
							Restez connectés avec nous sur nos réseaux sociaux pour ne rien manquer de nos actualités, événements et informations importantes.
						</p>
					</div>
				</div>

				<div className="footer-right">
					<div className="footer-contact">
						<h4>Adresse / Téléphone</h4>
						<p>Université IUSSE</p>
						<p>
							Tél: <strong>07 09 77 40 16</strong> |{' '}
							<strong>07 07 19 85 28</strong> |{' '}
							<br></br>
							<strong>27 34 71 23 48</strong> |{' '}
							<strong>27 34 71 07 08</strong> |{' '}
							<strong>07 07 25 75 79</strong>
						</p>
						<p>E-mail: <strong>iusse.sanpedro@gmail.com</strong></p>
						<p><strong>contact@iussesanpedro-ci.com</strong></p>
						<p>Ouvert du lundi au vendredi de 8h à 18h</p>
					</div>
				</div>
			</div>

			<div className="footer-bottom">
				<p>© 2025 Université IUSSE — Tous droits réservés.</p>
			</div>
		</footer>
	);
}